module.exports = __webpack_public_path__ + "static/img/1.0da5d59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/checkin/1.png
// module id = 1gA7
// module chunks = 0